import {catchError, from, map, Observable} from 'rxjs';
import {AxiosError, AxiosResponse} from 'axios';

import {DocumentInfo, DocumentKind} from '@store/files/files.model';

import SnackError from '@utils/error.utils';
import APIAxios, {APIRoutes} from '@api/axios.api';

export class FilesService {
  uploadFile = (file: File, kind: DocumentKind): Observable<DocumentInfo> => {
    const formData = new FormData();

    formData.append('document', file);
    formData.append('name', file.name);
    formData.append('documentKind', kind);

    return from(APIAxios({
      ...APIRoutes.POSTClassicDocument(),
      data: formData,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<DocumentInfo>) => {
          return {...response.data, file};
        }),
      );
  };

  getDocumentUrl = (documentId: number | string) => {
    return (APIAxios.defaults.baseURL || '') + APIRoutes.GETDocumentUrl(documentId).url;
  };

  openUrlInNewTab = (url: string) => {
    if (!url) return;

    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  downloadDocument = (data: any, filename: string) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.setAttribute('download', filename);
    link.click();
    link.parentNode?.removeChild(link);
  };
}

export const filesService = new FilesService();
